
export interface INavData {
  name: string;
  titolo?: string;
  component?: string;
  active?: boolean,
  href?: string;
  iconClass?: string;
  isTitle?: boolean;
  class?: string;
  classText?: string;
  visible: boolean;
}

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    visible: false,
    active: true,
    component: 'CrmDashboardComponent',
    iconClass: 'bi bi-graph-up-arrow'
  },
  {
    name: 'Contatti',
    visible: true,
    titolo: 'Contatti',
    component: 'CrmContattiComponent',
    active: false,
    iconClass: 'bi bi-person-vcard'
  },
  {
    name: 'Email Inviate',
    visible: true,
    component: 'CrmEmailInviateComponent',
    active: false,
    iconClass: 'bi bi-envelope-fill',

  },
  {
    name: 'Statistiche',
    visible: true,
    active: false,
    component: 'CrmStatisticheComponent',
    iconClass: 'bi bi-speedometer2'
  },
  /*   {
      name: 'Tipo Procedure',
      visible:true,
      component: 'CrmTipoProcedureComponent',
      active: false,
      iconClass: 'bi bi-file-earmark-text'
    }, */

  /*   {
      name: 'Clienti',
      visible:true,
      component: 'TestComponent',
      active: false,
      iconClass: 'bi bi-person-square'
    }, */
  {
    isTitle: true,
    name: 'Tabelle',
    visible: true,
    active: false,
  },
  {
    name: 'Procedure',
    visible: true,
    component: 'CrmProcedureComponent',
    active: false,
    iconClass: 'bi bi-journal-text'
  },
  // {
  //   name: 'Aggiornamenti',
  //   visible: true,
  //   component: 'CrmAggiornamentiComponent',
  //   active: false,
  //   iconClass: 'bi bi-list-columns-reverse'
  // },
  {
    name: 'Agenti',
    visible: true,
    component: 'CrmAgentiComponent',
    active: false,
    iconClass: 'bi bi-briefcase'
  },
  {
    name: 'Banche',
    visible: true,
    component: 'CrmBancheComponent',
    active: false,
    iconClass: 'bi bi-bank'
  },
  {
    name: 'Tags',
    visible: true,
    component: 'CrmTagsListComponent',
    active: false,
    iconClass: 'bi bi-tags'
  },
  {
    name: 'Comuni',
    visible: true,
    component: 'CrmComuniComponent',
    active: false,
    iconClass: 'bi bi-globe2'
  },
]